import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import React, { useState, useEffect } from "react";
import styles from "./homepage.module.css";
import PreviewIcon from "@mui/icons-material/Preview";
import EditIcon from "@mui/icons-material/Edit";
import FlightIcon from "@mui/icons-material/Flight";
import { useNavigate } from "react-router-dom";
import {
  createNewObjectsInFoundry,
  getDemoAirwaysAircraftObjectsFromFoundry,
  getDemoAirwaysFlightsObjectsFromFoundry,
  getObjectsFromFoundry,
  modifyObjectsInFoundry,
} from "../../service/foundryService";
import {
  Alert,
  Autocomplete,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { useSelector } from "react-redux";

const columns = [
  { id: "displayName", label: "Flight", minWidth: 30 },
  { id: "flightNumber", label: "Flight Number", minWidth: 50, align: "left" },
  {
    id: "scheduledTimeDeparture",
    label: "Scheduled Departure Time",
    minWidth: 60,
    align: "left",
  },
  {
    id: "scheduledTimeArrival",
    label: "Scheduled Arrival Time",
    minWidth: 60,
    align: "left",
  },
  {
    id: "compensationCostEst",
    label: "Compensation Cost",
    minWidth: 100,
    align: "left",
  },
  {
    id: "hotelCostEst",
    label: "Hotel Cost",
    minWidth: 80,
    align: "left",
  },
  {
    id: "maintenanceImpact",
    label: "Maintenance Impact",
    minWidth: 80,
    align: "left",
  },
];

const Homepage = (props) => {
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [viewRow, setViewRow] = useState("");
  const [viewSpinner, setViewSpinner] = useState(false);
  const [programType, setProgramType] = useState("");
  const navigate = useNavigate();
  const isAuthenticate = useSelector((state) => state.auth.isAuthenticate);
  const isCognitoAuthenticated = useSelector(
    (state) => state.auth.isCognitoAuthenticated
  );
  const cognitoToken = useSelector((state) => state.auth.cognitoToken);
  const foundryToken = useSelector((state) => state.auth.foundryToken);
  const [editNew, setEditNew] = useState({
    skywiseFlightId: "",
    displayName: "",
    flightNumber: "",
    scheduledTimeDeparture: "",
    scheduledTimeArrival: "",
    flightId: "",
    cancellationInfoId: "",
    compensationCostEst: 0.0,
    maintenanceImpact: "false",
    created: "",
    hotelCostEst: 0.0,
  });
  const [decission, setDecission] = useState([
    {
      cancellationInfoId: "",
      flightTitle: "",
      compensationCostEst: 0.0,
      maintenanceImpact: false,
      created: "",
      hotelCostEst: 0.0,
      skywiseFlightId: "",
    },
  ]);
  const [flightsData, setFlightsData] = useState([
    {
      skywiseFlightId: "",
      displayName: "",
      flightNumber: "",
      scheduledTimeArrival: "",
      scheduledTimeDeparture: "",
    },
  ]);
  const [flightData, setFlightData] = useState([
    {
      skywiseFlightId: "",
      displayName: "",
      flightNumber: "",
      scheduledTimeDeparture: "",
      scheduledTimeArrival: "",
      flightId: "",
      cancellationInfoId: "",
      compensationCostEst: 0.0,
      maintenanceImpact: "false",
      created: "",
      hotelCostEst: 0.0,
    },
  ]);
  // const [flightsState, flightsReducer] =
  const [aircraftsData, setAircraftsData] = useState([
    {
      skywiseAircraftId: "",
      aircraftProgram: "",
      aircraftRegistration: "",
    },
  ]);
  const [aircraftsDataFilter, setAircraftsDataFilter] = useState([
    {
      skywiseAircraftId: "",
      aircraftProgram: "",
      aircraftRegistration: "",
    },
  ]);
  const [selectedAircraft, setSelectedAircraft] = useState(null);
  const getAircraftData = async () => {
    try {
      setViewSpinner(true);
      let data = await getDemoAirwaysAircraftObjectsFromFoundry(
        foundryToken,
        cognitoToken
      );
      let flightDataWithoutSkywise = await getDemoAirwaysFlightsObjectsFromFoundry(
        "",
        foundryToken,
        cognitoToken
      )
      setFlightsData(flightDataWithoutSkywise);
      setAircraftsData(data);
      setAircraftsDataFilter(data)
      setViewSpinner(false);
    } catch (error) {
      console.error("401");
      setViewSpinner(false);
    }
  };
  useEffect(() => {
    if (!isAuthenticate || !isCognitoAuthenticated) {
      navigate("/login");
    }
    if (isAuthenticate) {
      getAircraftData();
    }
  }, []);
  const refreshData = async () => {
    try {
      if (selectedAircraft) {
        setViewSpinner(true);
        let data = await getDemoAirwaysFlightsObjectsFromFoundry(
          selectedAircraft.skywiseAircraftId,
          foundryToken,
          cognitoToken
        )
        setFlightsData(data);
        let dataDecission = await getObjectsFromFoundry(foundryToken, cognitoToken)
        setDecission(dataDecission);
        setViewSpinner(false);
      }
    } catch (error) {
      console.error("401");
      setViewSpinner(false);
    }
  };
  useEffect(() => {
    refreshData();
  }, [selectedAircraft]);
  useEffect(() => {
    setViewSpinner(true);
    let map = new Map();
    let data = [];
    // if(decission.length >1){
    for (var i = 0; i < decission.length; i++) {
      map.set(decission[i].skywiseFlightId, decission[i]);
    }
    for (var i = 0; i < flightsData.length; i++) {
      let options = { year: "numeric", month: "short", day: "numeric" };
      let timeDeparture = new Date(flightsData[i].scheduledTimeDeparture);
      let arrivalTime = new Date(flightsData[i].scheduledTimeArrival);

      let scheduledTimeDeparture =
        timeDeparture.toLocaleDateString("en-US", options) +
        " " +
        timeDeparture.toLocaleTimeString();
      let scheduledTimeArrival =
        arrivalTime.toLocaleDateString("en-US", options) +
        " " +
        arrivalTime.toLocaleTimeString();
      if (map.get(flightsData[i].skywiseFlightId)) {
        data.push({
          skywiseFlightId: flightsData[i].skywiseFlightId,
          displayName: flightsData[i].displayName,
          flightNumber: flightsData[i].flightNumber,
          scheduledTimeDeparture: scheduledTimeDeparture,
          scheduledTimeArrival: scheduledTimeArrival,
          cancellationInfoId: map.get(flightsData[i].skywiseFlightId)
            .cancellationInfoId,
          compensationCostEst: map.get(flightsData[i].skywiseFlightId)
            .compensationCostEst,
          maintenanceImpact: map.get(flightsData[i].skywiseFlightId)
            .maintenanceImpact
            ? "true"
            : "false",
          created: map.get(flightsData[i].skywiseFlightId).created,
          hotelCostEst: map.get(flightsData[i].skywiseFlightId).hotelCostEst,
        });
      } else {
        data.push({
          skywiseFlightId: flightsData[i].skywiseFlightId,
          displayName: flightsData[i].displayName,
          flightNumber: flightsData[i].flightNumber,
          scheduledTimeDeparture: scheduledTimeDeparture,
          scheduledTimeArrival: scheduledTimeArrival,
          cancellationInfoId: null,
          compensationCostEst: null,
          maintenanceImpact: null,
          created: null,
          hotelCostEst: null,
        });
      }
    }
    // }
    setFlightData(data);
    setViewSpinner(false);
  }, [decission, flightsData]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOnChange = (e) => {
    e.preventDefault();

    setEditNew({ ...editNew, decision: e.target.value });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleOnAddNewDicision = () => {
    setViewSpinner(true);
    let compensationCostEst = parseFloat(editNew.compensationCostEst);
    let hotelCostEst = parseFloat(editNew.hotelCostEst);
    if (editNew.cancellationInfoId === null) {
      let data = {
        DemoAirwaysFlight: editNew.skywiseFlightId,
        compensation_cost_est: compensationCostEst,
        hotel_cost_est: hotelCostEst,
        maintenance_impact: editNew.maintenanceImpact === "true" ? true : false,
      };
      // console.log(data)
      createNewObjectsInFoundry(data, foundryToken, cognitoToken).then(
        (res) => {
          refreshData();

          // setViewSpinner(false);

          setOpen(false);
        }
      );
    } else {
      let data = {
        SkywiseDemoFlightCancellationInformation: editNew.cancellationInfoId,
        compensation_cost_est: compensationCostEst,
        hotel_cost_est: hotelCostEst,
        maintenance_impact: editNew.maintenanceImpact === "true" ? true : false,
      };
      // console.log(data)
      modifyObjectsInFoundry(data, foundryToken, cognitoToken).then((res) => {
        refreshData();

        // setViewSpinner(false);
        setOpen(false);
      });
    }
  };
  const viewHandler = (data) => {
    setViewRow(JSON.stringify(data, null, 4));
  };
  const editDicision = (data) => {
    setEditNew(data);
    setOpen(true);
  };
  const programeTypeChangeHandler = (event) => {
    console.log("----------------"+programType)
    setProgramType(event.target.value);
    let dataTy = aircraftsData.filter((data) => {
      return data.aircraftProgram.match(event.target.value);
    });

    setAircraftsDataFilter(dataTy);
    setSelectedAircraft(null);
  };
  return (
    <Paper
      sx={{ padding: "32px", marginLeft: "1%", marginRight: "1%" }}
      elevation={3}
    >
      <Alert severity="info">
        This application showcase the usage of Skywise API by an external
        application
      </Alert>
      <Grid container spacing={2}>
        <Grid item xs={12}></Grid>
        <Grid item xs={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Program
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={programType}
              label="Program Type"
              onChange={programeTypeChangeHandler}
            >
              <MenuItem hidden={true} value=""></MenuItem>
              <MenuItem value="A320">A320</MenuItem>
              <MenuItem value="A350">A350</MenuItem>
              <MenuItem value="A380">A380</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={aircraftsDataFilter}
            getOptionLabel={(option) => option.aircraftRegistration}
            isOptionEqualToValue={(option, value) =>
              option.skywiseAircraftId === value.skywiseAircraftId
            }
            renderOption={(props, aircraftsDataFilter) => (
              <Box component="li" {...props}>
                <IconButton color="success" variant="contained">
                  <FlightIcon color="success" />
                </IconButton>{" "}
                &nbsp;
                {aircraftsDataFilter.aircraftRegistration}
              </Box>
            )}
            noOptionsText={"No Aircraft Available"}
            renderInput={(params) => (
              <TextField {...params} label="Select Aircraft" />
            )}
            value={selectedAircraft}
            onChange={(event, newValue) => setSelectedAircraft(newValue)}
          />
        </Grid>
        <Grid item mdOffset={4} md={2}>
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            sx={{ float: "right" }}
            startIcon={<Refresh />}
            onClick={refreshData}
          >
            Refresh
          </Button>
        </Grid>
        <Grid item xs={12}>
          {viewSpinner && <LinearProgress color="success" />}
        </Grid>
        <Grid item xs={12}>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell align="center" key="actions">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                {flightData[0].skywiseFlightId && (
                  <TableBody>
                    {flightData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.skywiseFlightId}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                            })}
                            <TableCell align="center" key="actionsfff">
                              <Stack direction="row" spacing={1}>
                                <IconButton
                                  aria-label="View"
                                  color="info"
                                  onClick={() => viewHandler(row)}
                                >
                                  <PreviewIcon />
                                </IconButton>
                                <IconButton
                                  aria-label="Edit"
                                  color="secondary"
                                  onClick={() => editDicision(row)}
                                >
                                  <EditIcon />
                                </IconButton>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15]}
              component="div"
              count={flightsData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card variant="outlined">
            <pre>
              <code>{viewRow}</code>
            </pre>
          </Card>
        </Grid>
      </Grid>
      <Dialog fullWidth={true} open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Flight Cancellation Information</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="compensationCostEst"
            label="Compensation Estimated Cost"
            type="number"
            fullWidth
            variant="outlined"
            step="0.1"
            value={
              editNew.compensationCostEst === null
                ? 0.0
                : editNew.compensationCostEst
            }
            onChange={(event) =>
              setEditNew({
                ...editNew,
                compensationCostEst: event.target.value,
              })
            }
          />
          <TextField
            autoFocus
            margin="dense"
            id="hotelCostEst"
            label="Hotel Estimated Cost"
            type="number"
            fullWidth
            step="0.1"
            variant="outlined"
            value={editNew.hotelCostEst === null ? 0.0 : editNew.hotelCostEst}
            onChange={(event) =>
              setEditNew({ ...editNew, hotelCostEst: event.target.value })
            }
          />

          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label-test">
              Maintenance Impact
            </InputLabel>
            <Select
              labelId="demo-simple-select-label-test"
              id="demo-simple-select"
              value={
                editNew.maintenanceImpact === null
                  ? false
                  : editNew.maintenanceImpact
              }
              label="Maintenance Impact"
              onChange={(event) =>
                setEditNew({
                  ...editNew,
                  maintenanceImpact: event.target.value,
                })
              }
            >
              <MenuItem value="true">true</MenuItem>
              <MenuItem value="false">false</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleOnAddNewDicision}>SAVE</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default Homepage;
